import { modules } from "../../components/modules";
import { FLOW_MESSAGES } from "../../components/shared/components/flowMessages/components";
import { SECTIONS } from "../config";
import { replaceModuleInModulesArrayByModuleId } from "./utils";
import { flowCaixabankUnknownCustomerBREnabled } from "./flowCaixabankUnknownCustomerBREnabled";

const newIncomeModule = {
  id: modules.DECLARED_INCOME.id,
  section: {
    name: SECTIONS.FINANCES,
    progressPercentage: "50%",
  },
  onAppResume: {
    conditionsToBeInitialModuleInFlow: (processState) =>
      processState.loan?.borrower_user_details_on_origination
        ?.familiar_situation_details &&
      !processState.loan?.borrower_bank_reader_id &&
      !processState.loan?.declared_income_id,
    welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
  },
};

export const flowCaixabankUnknownCustomerBRDisabled = {
  name: "CaixaBank Unknown Customer BR Disabled",
  modules: replaceModuleInModulesArrayByModuleId(
    flowCaixabankUnknownCustomerBREnabled.modules,
    modules.BANK_READER.id,
    newIncomeModule
  ),
};
